import { Form } from "antd";
import UploadFile from "../common/UploadFile";
import DownloadFile from "../common/DownloadFile";
import { useIntl } from "react-intl";

type Props = { close: () => void };

const PopBulkUpload = ({ close }: Props) => {
  const onFinish = (values: any) => {
    // Handle form submission here
    console.log("Received values:", values);
  };
  const normFile = (e: any) => {
    console.log("Upload event:", e);
    if (Array.isArray(e)) {
      return e;
    }
    return e?.fileList;
  };
  const intl = useIntl();

  return (
    <div className="p-6 max-md:p-3">
      <div className="bg-white rounded-2xl text-center p-8 max-md:p-4 shadow-lg">
        <span className="mt-8 text-color-primary font-semibold text-2xl w-full ">
          {intl.formatMessage({
            id: "bulkUploadForYourClients",
          })}
        </span>
        <Form
          name="upload"
          onFinish={onFinish}
          layout="vertical"
          className="my-8"
        >
          <Form.Item
            name="dragger"
            valuePropName="fileList"
            getValueFromEvent={normFile}
            noStyle
            className="w-full"
          >
            <DownloadFile />
            <UploadFile close={close} />
          </Form.Item>
        </Form>
      </div>
    </div>
  );
};

export default PopBulkUpload;
